import { useState } from "react";
import { useLocation, useNavigate, Navigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { useSeo } from "../lib/seo";
import { useAuth } from "./AuthContext";
import { LogoMark } from "../components/layout/Logo";

export default function AdminLogin() {
  useSeo({ title: "Admin Login", robots: "noindex,nofollow" });
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to={loc.state?.from || "/admin"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data.user);
      navigate(loc.state?.from || "/admin", { replace: true });
    } catch (err) { setError(errorMessage(err)); } finally { setBusy(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-ab-soft px-4">
      <form onSubmit={submit} className="card-ab w-full max-w-sm p-8" data-testid="admin-login-form">
        <div className="flex items-center gap-3"><LogoMark /><span className="font-serif text-xl font-semibold">ArticleBlogs <span className="text-ab-muted">CMS</span></span></div>
        <h1 className="mt-6 flex items-center gap-2 font-serif text-2xl font-semibold"><Lock size={18} /> Sign in</h1>
        <div className="mt-6 space-y-4">
          <div><label htmlFor="email" className="label-ab">Email</label><input id="email" type="email" required autoComplete="username" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="input-ab" data-testid="admin-login-email-input" /></div>
          <div><label htmlFor="password" className="label-ab">Password</label><input id="password" type="password" required autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="input-ab" data-testid="admin-login-password-input" /></div>
        </div>
        {error && <p role="alert" className="mt-4 rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="btn-primary mt-6 w-full disabled:opacity-60" data-testid="admin-login-submit-button">{busy ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
